/*
 * Page-level entries are this microsite's own concern. The externalized shell
 * set (header/footer/sliders, PM-312) comes from the shared fragment in
 * yoda-app-shell so every microsite carries the identical definition.
 */
const {
    getExternalizedShellRegistry,
} = require('yoda-app-shell/lib/mfe/externalMfComponents');

const yodaSiteComponents = {
    GoogleAutoSuggestAddress: {
        importFn: () => import('yodaSiteComponents/GoogleAutoSuggestAddress'),
        path: 'yodaSiteComponents/GoogleAutoSuggestAddress',
        type: 'class',
        isSSR: false,
    },
    ...getExternalizedShellRegistry(),
};

module.exports = { yodaSiteComponents };
